// Track page views on route change for Google Analytics
export const onRouteUpdate = ({ location, prevLocation }) => {
  const gaTrackingId = process.env.GATSBY_GA_TRACKING_ID;
  if (typeof window !== 'undefined' && window.gtag && gaTrackingId) {
    // Track page view with gtag
    window.gtag('config', gaTrackingId, {
      page_path: location.pathname + location.search + location.hash,
      page_title: document.title,
      page_location: window.location.href
    });
    
    // Track custom page_view event
    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search + location.hash
    });
    
    console.log('GA Route Tracked:', location.pathname); // For debugging
  }
};

// Track initial page load
export const onInitialClientRender = () => {
  const gaTrackingId = process.env.GATSBY_GA_TRACKING_ID;
  if (typeof window !== 'undefined' && window.gtag && gaTrackingId) {
    window.gtag('config', gaTrackingId, {
      page_path: window.location.pathname + window.location.search + window.location.hash,
      page_title: document.title,
      page_location: window.location.href
    });
    
    console.log('GA Initial Load Tracked:', window.location.pathname); // For debugging
  }
};
